"use client"
import React from 'react'
import Navbar from '../../components/agent/common/Navbar'
import MainClientHistory from "../../components/admin/ClientHistory/MainClientHistory"
const AgentClientHistory = () => {

  return (
    <div className="min-h-screen">
    <Navbar />
    <main className="p-4 md:p-10">
    <MainClientHistory/>
    </main>
  </div>
  )
}

export default AgentClientHistory
